<template>
  <el-form>
    <vuedraggable v-model="rightArr" @end="end">
      <div
        draggable="true"
        class="banner-f-item"
        v-for="(item, key) in rightArr"
        :key="key"
        :class="[
          checkedArr.includes(key) ? 'banner-error' : '',
          submitText === '轮播图' ? 'banner-box-item' : '',
        ]"
      >
        <el-form-item>
          <div class="b-f-title">
            <p class="l">
              <i class="iconfont icon-weibiaoti-1-04"></i>
              {{ submitText }}{{ key + 1 }}
            </p>
            <el-button
              type="text"
              class="r del"
              @click.stop.stop="removeBanner(key)"
              >删除</el-button
            >
          </div>
          <div class="banner-con">
            <div class="b-c-left">
              <p v-if="submitText !== '轮播图'" class="edit-title">
                名称:
                <template v-if="!item.name_edit_status">
                  <span @click.stop="itemTextStatus(item, key)">{{
                    item.name
                  }}</span>
                </template>

                <el-input
                  v-else
                  type="text"
                  v-focus
                  maxlength="6"
                  @blur="item.name_edit_status = false"
                  v-model.trim="item.name"
                />
              </p>
              <p class="set-image-name text-hidden">
                图片:
                <el-tooltip
                  effect="light"
                  :content="item.img_name"
                  placement="left"
                >
                  <span>{{ item.img_name }}</span>
                </el-tooltip>
              </p>
              <!-- {{ item.path_type }} -->
              <p>
                链接:
                <el-tooltip
                  v-if="item.path_type === 1"
                  effect="light"
                  :content="`文件夹-${item.directories_name}`"
                  placement="left"
                >
                  <span
                    class="text-hidden link-active"
                    @click.stop="openDialog(key)"
                    >文件夹-{{ item.directories_name }}</span
                  >
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.path_type === 2"
                  effect="light"
                  :content="`模板-${item.template_name}`"
                  placement="left"
                >
                  <span
                    class="text-hidden link-active"
                    @click.stop="openDialog(key)"
                    >模板-{{ item.template_name }}</span
                  >
                </el-tooltip>
                <span
                  class="text-hidden link-active"
                  @click.stop="openDialog(key)"
                  v-else
                  >点击设置链接 <i class="iconfont icon-Unfold1"></i
                ></span>
              </p>
            </div>
            <div class="b-c-right">
              <!-- :action="uploadUrl"
                        :headers="headers"
                             :on-success="(res) => uploadOnSuccess(res, key)"
              :on-error="errorUpload"
              :on-change="errorUpload"
                        
                         -->
              <el-upload
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="(params) => uploadImage(params, key)"
                :data="uploadType"
              >
                <img
                  v-if="item.url"
                  width="68"
                  height="68"
                  :src="item.url"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                <div class="upload-hover" v-if="item.url">
                  <p>替换</p>
                </div>
              </el-upload>
            </div>
          </div>
          <p
            class="error-text"
            :style="submitText === '轮播图' ? { bottom: '-50px' } : {}"
            v-if="checkedArr.includes(key)"
          >
            设置不完整
          </p>
        </el-form-item>
      </div>
    </vuedraggable>

    <el-form-item v-if="submitText.length" class="form-btn">
      <el-button
        type="primary"
        class="add-banner-btn"
        v-if="rightArr.length < len"
        @click.stop="addBanner"
        >添加{{ submitText }}</el-button
      >
      <!-- <el-button
        class="add-banner-btn"
        v-if="rightArr.length === len"
        @click.stop="saveBanner"
        >保存{{ submitText }}</el-button
      > -->
    </el-form-item>
  </el-form>
</template>

<script>
import { HomeSetting } from "@/config/axios/api"
import vuedraggable from "vuedraggable"
export default {
  props: {
    rightArr: {
      type: Array,
      default: () => [],
    },
    len: {
      type: Number,
      default: 3,
    },
    checkedArr: {
      type: Array,
      default: () => [],
    },
    submitText: {
      type: String,
      default: "",
    },
    uploadType: {
      type: Object,
      default: () => {
        return { upload_type: 1 }
      },
    },
  },
  components: {
    vuedraggable,
  },
  data() {
    return {
      dragging: null,
      list: [],
    }
  },
  methods: {
    end () {
      this.$emit("toggleData", this.rightArr);
      this.$nextTick(() => {
        this.$emit("saveBanner");
      });
    },
    addBanner(e) {
      this.buttonBlur(e) 
      this.$emit("toggleData", this.rightArr)
      this.$emit("addBanner")
    },
    saveBanner() {
      this.$emit("toggleData", this.rightArr)
      this.$emit("saveBanner");
    },
    removeBanner(key) {
      this.$emit("toggleData", this.rightArr)
      this.$emit("removeBanner", key);
    },
    openDialog(key) {
      this.$emit("toggleData", this.rightArr)
      this.$emit("openDialog", key)
    },
    handleDragStart(e, item) {
      this.dragging = item
    },
    handleDragEnd() {
      this.dragging = null
    },
    uploadImage(params, key) {
      let file = params.file
      var dotIndex = file.name.lastIndexOf(".") + 1
      var fileTypeStr = file.name.slice(dotIndex)
      let img = ["png", "jpeg", "jpg"]
      if (!img.includes(fileTypeStr)) {
        this.$message({
          message: "请上传png、jpeg、jpg图片",
          center: true,
          customClass: "handle-success",
        })
        return
      }
      let data = {
        file: file,
        format: fileTypeStr,
        upload_type: 'other'
      };
      this.staticFunc.qyUploadImg(data, (res) => {
        if (res.status === 1) {
            this.$message.success("上传成功");
            this.$emit("uploadSucess", res.url, key);
        } else {
            this.$message.error(res.message);
        }
      })
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move" // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move" //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return
      }
      // const newItems = [...this.list];
      // const src = newItems.indexOf(this.dragging);
      // const dst = newItems.indexOf(item);

      // newItems.splice(dst, 0, ...newItems.splice(src, 1));
      // this.list = newItems;

      // this.$emit("toggleData", item)
    },
    itemTextStatus(item) {
      item.name_edit_status = true
    },
    errorUpload() {
      //console.log(res);
    },
  },
}
</script>
<style lang="scss" scoped>
.right-name-inp {
  width: 100px;
}
</style>

<style lang="scss" scoped>
.banner-f-item {
  @include wh(272px, 150px);
  background: #fff;
  padding: 16px 20px 0;
  border-radius: 8px;
  margin-bottom: 14px !important;
  transition: all linear 1s;
  &.banner-error {
    border: 1px solid red;
    margin-bottom: 36px !important;
  }
  .b-f-title {
    line-height: 30px;
    @include wh(100%, 44px);
    padding-bottom: 14px;
    // h3 {
    //   float: left;
    // }
    p {
      color: #3b3946;
    }
    i {
      color: #aaaaa1;
    }
  }
}
.banner-con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .b-c-left {
    p {
      line-height: 28px;
      font-size: 14px;
      color: #666;
      @include wh(150px, 28px);
      overflow: hidden;
      span.text-hidden {
        display: inline-block;
        max-width: 113px;
        vertical-align: bottom;
        cursor: pointer;
      }
      .link-active {
        color: $activeColor;
        .icon-Unfold1 {
          font-size: 18px;
          /* margin-top: 2px; */
          display: inline-block;
          position: relative;
          top: 2px;
          left: -5px;
        }
      }
      &.edit-title {
        display: flex;
        span {
          display: inline-block;
          width: 110px;
          height: 28px;
          cursor: pointer;
        }
      }
    }
  }
}
.b-c-right {
  .avatar-uploader {
    @include wh(68px, 68px);
    background: #f3f3f3;
    border-radius: 8px;
    border: 1px solid #dddddd;
    position: relative;
    overflow: hidden;
    .el-icon-plus {
      font-size: 22px;
      line-height: 68px;
      @include wh(68px, 68px);
    }
    .upload-hover {
      @include wh(100%, 100%);
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      line-height: 68px;
      display: none;
    }
    &:hover {
      .upload-hover {
        display: block;
      }
    }
  }
}
.add-banner-btn {
  @include wh(272px, 40px);
  // background: linear-gradient(180deg, #646470 0%, #3c3c4b 100%);
  // border-radius: 8px;
  // color: #fff;
  // &:hover,
  // &:active,
  // &:link {
  //   color: #fff;
  // }
}
.banner-box-item {
  height: 133px;
  .b-f-title {
    height: 34px;
    p {
      height: 20px;
      line-height: 20px;
    }
  }
  .b-c-left {
    padding-top: 12px;
  }
}
</style>

<style lang="scss">
.b-c-left {
  .edit-title {
    .el-input {
      width: 100px;
    }
  }
}
.drawer-con {
  .el-button--text {
    margin-top: 7px;
  }
  .del {
    color: #999;
    &:hover {
      color: #000;
    }
  }
}
.banner-box-item {
  .el-button--text {
    margin-top: 2px;
  }
}
</style>
